'use strict';

DoohApps.filter('CacheSafeUrl', function () {
    return function (url, date) {
        if (typeof url == 'string')
            return url != null && url != undefined ? `${url}?date=${date}` : url;
        else
            return url;
    }
})